/**
 * 全局配置文件
 */
export default {

  clientId: 'admin', // 客户端id
  clientSecret: 'admin_secret', // 客户端密钥
  tokenTime: 3000,
  tokenHeader: 'Zz-Auth',
  //http的status默认放行列表
  statusWhiteList: [],


}



// WEBPACK FOOTER //
// ./src/config/website.js